import { render, staticRenderFns } from "./KeyboardShortcuts.vue?vue&type=template&id=d3f51220&scoped=true&"
import script from "./KeyboardShortcuts.vue?vue&type=script&lang=js&"
export * from "./KeyboardShortcuts.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardShortcuts.vue?vue&type=style&index=0&id=d3f51220&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../morphology/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f51220",
  null
  
)

export default component.exports